import { CustomFilterConfig } from '../types/filter-config';
import { FilterItemConfigOptions } from '../types/filter-item-config-options';
import { FilterStateFactoryRef } from './filter.function';
import { CustomFilter } from '../types/filter';
import { QueryFilter } from '@softline/core';
import { BooleanFilterOperator } from '../types/filter-operators';
import { defaultFilterInputTypeFactory } from '../page-filter/helper/default-filter-input-type.factory';

export interface CustomFilterOptions<T extends object, TValue> extends FilterItemConfigOptions<T, TValue> {
  defaultOperator: BooleanFilterOperator;
  allowedOperators?: BooleanFilterOperator[];
  formatter: (value: TValue) => string;
  toQueryFilter: (filter: CustomFilter<T, TValue>) => QueryFilter<T>;
}

export function customFilter<T extends object, TValue>(
  ref: FilterStateFactoryRef<T>,
  options: CustomFilterOptions<T, TValue>): void {
  const config: CustomFilterConfig<T, TValue> = {
    ...options,
    type: 'custom',
    allowedOperators: options.allowedOperators ?? [options.defaultOperator],
    inputTypeFactory: defaultFilterInputTypeFactory,
  }
  ref.addItem(config);
}
